import React from "react";
import { Flex, Text, type TextProps } from "@jsq/ds/core";
import { Address } from "../../../common/types";

const stateOrRegion = (address: Address) => {
  const { state, region } = address;
  if (state) {
    return state;
  }
  return region;
};

const FormattedAddress = ({
  address,
  dataCy,
  className,
  variant = "regular-md",
}: {
  address: Address;
  dataCy?: string;
  className?: string;
  variant?: TextProps["variant"];
}) => {
  const { street, street2, street3, city, postalCode, country } = address || {};
  let cityStatePostal = "";
  if (city) {
    cityStatePostal = city;
  }
  const state = stateOrRegion(address);

  if (state && cityStatePostal.length > 0) {
    cityStatePostal = `${cityStatePostal}, ${state}`;
  } else if (state) {
    cityStatePostal = state;
  }

  if (postalCode && cityStatePostal.length > 0) {
    cityStatePostal = `${cityStatePostal} ${postalCode}`;
  } else if (postalCode) {
    cityStatePostal = postalCode;
  }

  return (
    <Flex flexDirection="column" data-cy={dataCy} className={className}>
      {street && <Text variant={variant}>{street}</Text>}
      {street2 && <Text variant={variant}>{street2}</Text>}
      {street3 && <Text variant={variant}>{street3}</Text>}
      {cityStatePostal && <Text variant={variant}>{cityStatePostal}</Text>}
      {country && <Text variant={variant}>{country}</Text>}
    </Flex>
  );
};

export default FormattedAddress;
